import { render, staticRenderFns } from "./superCCareGoods.vue?vue&type=template&id=7e538080&"
import script from "./superCCareGoods.vue?vue&type=script&lang=js&"
export * from "./superCCareGoods.vue?vue&type=script&lang=js&"
import style0 from "./superCCareGoods.vue?vue&type=style&index=0&id=7e538080&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports